export default __webpack_public_path__ + "static/media/img-0739-latvia-premium-face.a05087d7.png";